import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export interface ImageViewerDialogProps {
  open: boolean;
  onClose: () => void;
  url: string;
  filename?: string;
}

export const ImageViewerDialog: React.FC<ImageViewerDialogProps> = ({ open, onClose, url, filename = "Image" }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1 }}>
        {filename}
        <IconButton onClick={onClose} size="small" aria-label="Close image viewer">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 1.5, height: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <img src={url} alt={filename} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewerDialog;
